import { render, staticRenderFns } from "./DeliveryAddress.vue?vue&type=template&id=29e72cfb&scoped=true"
import script from "./DeliveryAddress.vue?vue&type=script&lang=ts"
export * from "./DeliveryAddress.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryAddress.vue?vue&type=style&index=0&id=29e72cfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e72cfb",
  null
  
)

export default component.exports